import { render, staticRenderFns } from "./AddUserToCompanyPage.vue?vue&type=template&id=23013622&scoped=true"
import script from "./AddUserToCompanyPage.vue?vue&type=script&lang=js"
export * from "./AddUserToCompanyPage.vue?vue&type=script&lang=js"
import style0 from "./AddUserToCompanyPage.vue?vue&type=style&index=0&id=23013622&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23013622",
  null
  
)

export default component.exports